export const namespace = 'queueStats'
